import { Box, type BoxProps } from '@frontend/components';

export type HorizontalFormFieldProps = BoxProps;

export const HorizontalFormField = (props: HorizontalFormFieldProps) => (
  <Box flexBasis="100%" flexGrow={1} flexShrink={1} {...props} />
);
